import { React, useEffect, useState } from "react";
import JobCardCylinderChild from "./JobCardCylinderChild";
import moment from "moment";
import {
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList";
import { Button, Col, Form, Input, Skeleton, Tooltip } from "antd";
import Iconmoon from "../IconsFiles/icon";
import { Styled } from "../../Pages/pageStyled";
import { EditSetsContainer, CylinderShimmer } from "../../Pages/styledElements";
import {
  cancelSets,
  cancelSetsMultistage,
  cylinderReorder,
  cylinderReorderMultistage,
} from "../../Services/productionPlanningServices";
import { useForm } from "antd/lib/form/Form";
import JobCardCylinderChildMultistage from "./JobCardCylinderChildMultistage";
import SheetJobCardCylinderMultistage from "./SheetJobCardCylinderMultistage";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
const JobCardCylinderMultistage = ({
  cylinderData,
  multiview,
  units,
  isValidState,
  jobId,
  cancelSetToggle,
  deckle_match_page = false,
  combinationNumber,
  solution,
  maxWidth,
  solId = "1",
  maxAvailableWidth,
  cylinderViewData
}) => {
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [inputText, setInputText] = useState(parseFloat(cylinderData.count));
  const [errorMsg, setErrorMsg] = useState();
  const [dragId, setDragId] = useState({});
  const [isLoading, setIsloading] = useState(false);
  const [leftEdgeTrim, setLeftEdgeTrim] = useState();
  const [rightEdgeTrim, setRightEdgeTrim] = useState();
  const [reRender, setRerender] = useState(false);
  const [cylinderOrders, setCylinderOrders] = useState(
    []
  );
  const [selectedIntermediateReel, setSelectedIntermediateReel] = useState(
    cylinderData.orders.map((order) => {
      return { isDispay: false };
    })
  );
  const [form] = useForm();
  useEffect(() => {
    // console.log(leftEdgeTrim, rightEdgeTrim);
  }, [leftEdgeTrim, rightEdgeTrim]);

  useEffect(() => {
    setRightEdgeTrim(cylinderData.right_edge_trim);
    setLeftEdgeTrim(cylinderData.left_edge_trim);
  }, [cylinderData, solId, solution, combinationNumber]);
  const handleDrop = (ev) => {
    // console.log(ev);
    if (!isEditEnabled || !cylinderData.allow_reel_rearranging) return;
    const target = JSON.parse(ev.currentTarget.id);
    // console.log(target)
    const dragCylinderIndex = cylinderOrders.findIndex(
      (cylinder) =>
        cylinder.uuid == dragId.uuid &&
        dragId.combinationNumber === cylinder.combinationNumber
    );
    const dropCylinderIndex = cylinderOrders.findIndex(
      (cylinder) =>
        cylinder.uuid == target.uuid &&
        target.combinationNumber === cylinder.combinationNumber
    );
    // console.log(combinationNumber, dropCylinderIndex, dragCylinderIndex, target, dragId)
    if (
      dragCylinderIndex === -1 ||
      dropCylinderIndex === -1 ||
      dragId.combinationNumber != target.combinationNumber
    )
      return;
    let newCylinderOrders = [...cylinderOrders];
    const draggedCylinder = newCylinderOrders.splice(dragCylinderIndex, 1)[0]; // Remove the dragged cylinder
    newCylinderOrders.splice(dropCylinderIndex, 0, draggedCylinder); // Insert the dragged cylinder at the drop position
    newCylinderOrders.map((order, index) => {
      order.left = -23 * index;
      return order;
    });
    setCylinderOrders(newCylinderOrders);
    setDragId({});
  };

  const openIntermediateReelSheets = (
    reel,
    isDispay,
    width,
    index,
    availableWidth
  ) => {
    setSelectedIntermediateReel((prevState) => {
      let widthSum = 0,
        totalWidth = calcWidth(),
        cnt = 0;
      let oldState = prevState.map((item, idx) => {
        if (idx === index) {
          return {
            ...item,
            ...reel,
            isDispay,
            reelWidth: width,
            availableWidth: availableWidth,
          };
        }
        return item;
      });
      return oldState.map((item, idx) => {
        const factor = cylinderData?.orders[idx]?.width / totalWidth;
        widthSum += !item?.isDispay ? factor : 0;
        cnt += !item?.isDispay;
        const margin =
          idx > 0 && oldState[idx - 1].isDispay
            ? 0
            : `calc(${widthSum * 100}% - ${cnt * 23}px)`;
        if (item?.isDispay) {
          cnt = 0;
          widthSum = 0;
        }
        return {
          ...item,
          marginLeft: margin,
        };
      });
    });
  };
  const handleEditSetsToggle = (isCancelled) => {
    setIsEditEnabled(!isEditEnabled);
   // form.resetFields();
    setErrorMsg();
    setInputText(parseFloat(cylinderData.count));
    setDragId({});
    isCancelled &&
      setCylinderOrders(
        cylinderData.orders.map((order, index) => {
          return {
            ...order,
            uuid: index,
            combinationNumber: combinationNumber,
          };
        })
      );
    setInputText(cylinderData.count);
    setErrorMsg();
    form.setFieldsValue({"cancel-set-input": cylinderData.count});
    setSelectedIntermediateReel(cylinderData.orders.map((order) => {
      return { isDispay: false };
    }))
  };
  const calcWidth = () => {
    let width = 0;
    cylinderData.orders.map((order) => (width += order.width));
    // if (leftEdgeTrim > 0) width += 25;
    // if (rightEdgeTrim > 0) width += 10;
    return width;
  };

  const validateInput = (newValue) => {
    const validInputPattern = /^\d+$/;
    if (validInputPattern.test(newValue)) {
      setInputText(newValue);
      setErrorMsg();
    } else {
      setErrorMsg("Enter a positive integer");
    }
  };
  const handleInputChange = (e) => {
    let newValue = e.target.value.trim();
    validateInput(newValue);
  };
  const handleSave = () => {
    // console.log(inputText);
    if (!inputText) {
      setErrorMsg("Please enter an integer");
      return;
    }
    const no_of_cancelled_sets =
      parseFloat(cylinderData.count) - parseFloat(inputText);
    let orderArray = cylinderOrders.map((order, index) => {
      return order.uuid;
    });
    const trimLossIndex = cylinderOrders.findIndex(
      (order, index) => order.item_type === "trim_loss"
    );
    // console.log(cylinderData.orders, orderArray, trimLossIndex)
    let originalTrimLossIndex = cylinderData.orders.findIndex(
      (order, index) => order.item_type === "trim_loss"
    );
    originalTrimLossIndex =
      originalTrimLossIndex === -1 ? orderArray.length : originalTrimLossIndex;
    if (trimLossIndex !== -1) {
      orderArray.splice(trimLossIndex, 1);
    }
    orderArray = orderArray.map((order) => {
      if (order > originalTrimLossIndex) order = order - 1;
      return order;
    });
    let cylinderReorderRequest = {
      jobcard: parseFloat(jobId),
      solution: solution,
      // repeated: cylinderData.actual_count,
      combination: combinationNumber,
      reel: orderArray,
      trim_loss: trimLossIndex,
    };
    const request = {
      jobcard_id: parseFloat(jobId),
      no_of_cancelled_sets,
      parent_reel_ids: cylinderData.parent_reel_ids.splice(
        0,
        no_of_cancelled_sets
      ),
    };
    setIsloading(true);
    cancelSetsMultistage(request)
      .then((response) => {
        // console.log(response);
        cylinderReorderMultistage(cylinderReorderRequest)
          .then((response) => {
            // console.log(response);
            // if (cancelSetToggle) cancelSetToggle();
            setErrorMsg();
            setInputText();
            setIsEditEnabled(false);
            if (cancelSetToggle) cancelSetToggle();
            setIsloading(false);
          })
          .catch((error) => {
            console.log(error.response.data.msg);
            setIsloading(false);
          });
      })
      .catch((error) => {
        setErrorMsg(error.response.data.msg);
        setIsloading(false);
      });
  };
  const widthSize = () => {
    const percentage = deckle_match_page ? 68 : 80;
    const max = maxWidth.max;
    const diff = maxWidth.maxDiff;
    let extraPixels = 0;
    const widthThreshold = window.screen.width / 2.8;
    // console.log(widthThreshold, max - diff);
    if (max - diff > widthThreshold) {
      extraPixels = max - diff - widthThreshold;
    }
    return `calc(${
      maxAvailableWidth - 200 + 23 * (maxWidth.maxReels - 1)
    }px + 100%})`;
  };
  useEffect(() => {
    setRerender(!reRender);
  }, [cylinderOrders, solId]);
  useEffect(() => { setCylinderOrders(cylinderData.orders.map((order, index) => {
    return { ...order, uuid: index, combinationNumber: combinationNumber };
  }))},[cylinderData])
  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <>
        <td
          class="ant-pipe-container"
          att={cylinderData.trim_loss}
          style={{
            width: `calc(100% + ${
              (cylinderData.orders.length - 1) * 23 - 210
            }px)`,
            maxWidth: widthSize(),
            // marginRight: '10px'
          }}
        >
          {leftEdgeTrim ? (
            <div
              style={{ width: "25px", position: "absolute", left: "-2px" }}
              class="cylinder-darkgray"
            >
              {" "}
              <Tooltip
                title={`Left Edge Trim\nWidth: ${leftEdgeTrim} ${
                  units?.left_edge_trim ? units?.left_edge_trim : "cm"
                }`}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                  }}
                />
              </Tooltip>{" "}
            </div>
          ) : null}
          {cylinderOrders.map((order, index, orders) => (
            // <div key={order.uuid} style={{width: '100%'}}>
            <JobCardCylinderChildMultistage
              order={order}
              classname={
                index + 1 === orders.length &&
                order.color !== "white" &&
                index == cylinderOrders.length - 1
                  ? // &&
                    // cylinderData.trim_loss == 0
                    `cylinder-${order.color}-last`
                  : `cylinder-${order.color}`
              }
              multiview={multiview}
              units={units}
              trimloss={cylinderData.trim_loss}
              totalWidth={calcWidth()}
              maxWidth={maxWidth.max}
              handleDrag={(ev) => {
                if (!isEditEnabled && !cylinderData.allow_reel_rearranging)
                  return;
                // console.log(ev.target.id)
                return setDragId(JSON.parse(ev.currentTarget.id));
              }}
              handleDrop={handleDrop}
              uuid={order.uuid}
              isValidState={
                isEditEnabled && cylinderData.allow_reel_rearranging
              }
              isLoading={isLoading}
              reRender={reRender}
              deckleMatchPage={deckle_match_page}
              index={index}
              openIntermediateReelSheets={openIntermediateReelSheets}
              cylinderViewData={cylinderViewData}
            />

            //  </div>
          ))}

          {/* </ReactSortable> */}
          {/* {console.log(calcWidth())} */}
        </td>{" "}
        {rightEdgeTrim ? (
          <div
            style={{
              width: "25px",
              position: "absolute",
              left: "calc(100% - 228px)",
            }}
            class="cylinder-darkgray"
          >
            {" "}
            <Tooltip
              title={`Right Edge Trim\nWidth: ${rightEdgeTrim} ${
                units?.right_edge_trim ? units?.right_edge_trim : "cm"
              }`}
            >
              <div
                style={{ width: "100%", height: "100%", position: "absolute" }}
              />
            </Tooltip>
          </div>
        ) : null}
        <span
          class="cylinder-text"
          style={{
            // width: deckle_match_page ? "32%" : "20%",
            width: "190px",
            float: "right",
            paddingLeft: deckle_match_page ? "1px" : "10px",
          }}
        >
          {/* {isLoading ? (
        <>
          <CylinderShimmer>
            <Skeleton
              paragraph={{ rows: 2 }}
              active={true}
              style={{
                width: "100%",
                margin: "0px",
                padding: "0px",
                margin: "0px",
              }}
              size={"small"}
              shape={"default"}
              className="shimmer"
            />
          </CylinderShimmer>
        </>
      ) : ( */}
          <>
            <p>
          Utilized: {
            cylinderData?.orders?.reduce((sum, item) => {
            const width = item.reel_type === "intermediate_reel"
              ? item.reel_width
              : item.order_width;

            return sum + (parseFloat(width) || 0);
          }, 0).toFixed(3)
            } {units?.order_width || 'cm'}            </p>
            <p>
              Dia: {cylinderData.reel_od ? cylinderData.reel_od : 0}{" "}
              {units?.reel_od ? units.reel_od : "cm"}
              {"/ "}
              {cylinderData.core_id ? cylinderData.core_id : 0}{" "}
              {units?.core_id ? units.core_id : "cm"}
            </p>{" "}
            <p
              style={{
                display: "flex",
                width: "100%",
                paddingRight: "7px",
              }}
            >
              <span style={{ width: "80%", display: "flex", maxWidth: "80px" }}>
                Sets:{" "}
                {!isEditEnabled ? (
                  cylinderData.count < 10 && cylinderData.count > 0 ? (
                    "0" + cylinderData.count
                  ) : (
                    cylinderData.count
                  )
                ) : (
                  <EditSetsContainer style={{ width: "60%" }}>
                    <Form form={form}>
                      <Form.Item
                        name="cancel-set-input"
                        initialValue={inputText}
                        style={{
                          margin: "0px",
                          padding: "0px",
                          minHeight: "0px",
                        }}
                      >
                        <Input
                          className="input"
                          size="small"
                          onChange={handleInputChange}
                          disabled={isLoading}
                        />
                      </Form.Item>
                    </Form>
                  </EditSetsContainer>
                )}
              </span>
              {isValidState && (
                <EditSetsContainer>
                  {!isEditEnabled ? (
                    <div className="edit-container">
                      {cylinderData?.count > 0 && (
                        <Styled>
                          <Tooltip
                            placement="bottom"
                            title={"Edit number of sets"}
                            className="edit-tooltip"
                          >
                            <Button
                              className="btn"
                              onClick={() => handleEditSetsToggle()}
                            >
                              <Iconmoon
                                icon="edit"
                                size={12}
                                style={{
                                  opacity: cylinderData?.count ? 1 : 0,
                                  transform: "translateX(-5px)",
                                }}
                                color="#8E8583"
                              />
                            </Button>
                          </Tooltip>
                        </Styled>
                      )}
                      {/* </Col> */}
                      {/* <Col span={12}> */}
                      <Styled>
                        <Tooltip
                          placement="bottom"
                          title={`Original Sets: ${cylinderData.actual_count}\nCancelled Sets: ${cylinderData.cancelled_count}`}
                          className="edit-tooltip"
                        >
                          <Button
                            className="btn"
                            // onClick={() => handleEditSetsToggle()}
                            style={{
                              width: cylinderData?.count > 0 ? "" : "100%",
                              marginLeft: cylinderData?.count > 0 ? "" : "10px",
                            }}
                          >
                            <Iconmoon
                              icon="info_new"
                              size={15}
                              color="#8E8583"
                              style={{
                                // opacity: 0.7,
                                marginTop: "2px",
                                float: "right",
                              }}
                            />
                          </Button>
                        </Tooltip>
                      </Styled>
                    </div>
                  ) : (
                    <div className="edit-container" style={{ width: "40%" }}>
                      {!errorMsg && (
                        <Tooltip placement="bottom" title="Save changes">
                          <Button
                            className="btn"
                            style={{
                              marginTop: "2px",
                              transform: isLoading && "translateY(-4px)",
                              background: "transparent !important",
                              cursor: "pointer",
                            }}
                            onClick={() => handleSave()}
                            loading={isLoading}
                          >
                            {!isLoading && (
                              <Iconmoon icon="check" size={14} color="green" />
                            )}
                          </Button>
                        </Tooltip>
                      )}
                      {!isLoading && (
                        <Tooltip placement="bottom" title="Discard changes">
                          <Button
                            className="btn"
                            style={{ marginTop: "2px" }}
                            onClick={() => handleEditSetsToggle(true)}
                            loading={isLoading}
                          >
                            <Iconmoon icon="cancel" size={14} color="red" />
                          </Button>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </EditSetsContainer>
              )}
            </p>
            <p
              // className="error"
              style={{
                color: "red",
                fontSize: "9px",
                margin: "0px",
                padding: "0px",
                transform: "translateY(-7px)",
                lineHeight: 1,
              }}
            >
              {errorMsg}
            </p>
          </>
        </span>
      </>
      <div
        style={{
          width: `calc(100% + ${
            (cylinderData.orders.length - 1) * 23 - 210
          }px)`,
          display: "flex",
        }}
      >
        {!(isEditEnabled && cylinderData.allow_reel_rearranging) && selectedIntermediateReel.map(
          (reel) =>
            reel.isDispay && (
              <div
                style={{
                  width: reel.reelWidth,
                  marginBottom: "5px",
                  marginLeft: reel.marginLeft,
                  // position: "absolute"
                }}
              >
                {" "}
                {/* {console.log(reel.availableWidth)} */}
                {reel.availableWidth > 50 ? (
                  <p style={{ width: "100%", height: "40px" }}>
                    (
                    {reel.intermediate_reels_data
                      .map((item) => item.size)
                      .join(" + ")}
                    ) x {reel.length}{" "}
                    {units ? lengthUnit[units.reel_width]?.displayName : "cm"}
                  </p>
                ) : (
                  <Styled>
                    <Tooltip
                      title={
                        "(" +
                        reel.intermediate_reels_data
                          .map((item) => item.size)
                          .join(" + ") +
                        ") x " +
                        reel.length + " " +
                        (units
                          ? lengthUnit[units.reel_width]?.displayName
                          : "cm")
                      }

                      // overlayClassName="cylinderSheetTooltip"
                    >
                      <p
                        style={{
                          width: "100%",
                          height: "40px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        (
                        {reel.intermediate_reels_data
                          .map((item) => item.size)
                          .join(" + ")}
                        ) x {reel.length}{" "}
                        {units
                          ? lengthUnit[units.reel_width]?.displayName
                          : "cm"}
                      </p>
                    </Tooltip>
                  </Styled>
                )}
                <SheetJobCardCylinderMultistage
                  currentCylinderData={reel}
                  isSingleCylinder={true}
                  units={units}
                />
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default JobCardCylinderMultistage;
